<template>
  <teleport to="body">
    <div :class="[
      'fixed left-0 right-0 top-0 bottom-0 transition-opacity cursor-pointer z-50',
      active ? 'opacity-100' : 'opacity-0 pointer-events-none'
    ]">

      <!-- background -->
      <div
        @click="close"
        class="w-full h-full bg-black/50"
      />

      <!-- dialog -->
      <dialog
        open
        :class="[
          'fixed left-0 right-0 top-0 bottom-0 w-[calc(100%_-_2rem)] md:w-fit md:p-6 rounded-lg modal-shadow transition-all mx-auto',
          active ? 'scale-100' : 'scale-50',
        ]"
      >
        <!-- title -->
        <h3 class="mt-4 mb-6 text-fontcolor-dark text-3xl font-bold text-center"> {{ title }} </h3>

        <!-- html content -->
        <slot></slot>

        <!-- close button -->
        <button
          type="button"
          @click="close"
          class="absolute top-3 right-3 flex items-center justify-center w-5 h-5 p-0 text-dark-grey text-5xl cursor-pointer"
        >
          ×
        </button>
      </dialog>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "adivare-modal",
  emits: ['close'],
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
      default: null,
    },
    className: {
      type: String,
      required: false,
      default: null,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>
